import React from "react";

const PaginationControls = ({ table, pagination, handlePageSizeChange }) => {
  return (
    <div className="d-lg-flex align-items-center mb-n2">
      <div className="d-lg-flex d-none align-items-center text-nowrap">
        Resultados por pagina:
        <select
          value={pagination.pageSize}
          onChange={handlePageSizeChange}
          id="table-pageSize"
          className="form-select form-select-sm ms-2 h-25px py-0 ps-2 pe-30px"
        >
          <option value="80">80 </option>
          <option value="40">40</option>
          <option value="25">25</option>
          <option value="15">15</option>
        </select>
      </div>
      <div className="d-lg-block d-none ms-2 text-body text-opacity-50">{table.getRowCount()} resultados encontrados</div>

      <ul className="pagination pagination-sm mb-0 ms-auto justify-content-center">
        <li className={"page-item " + (table.getCanPreviousPage() ? "" : "disabled")}>
          <button onClick={() => table.previousPage()} className="page-link">
            Anterior
          </button>
        </li>

        <span className="page-item ms-1 fs-15px">
          <span className="badge bg-white text-dark">
            pagina {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
          </span>
        </span>

        <li className={"page-item " + (table.getCanNextPage() ? "" : "disabled")}>
          <button className="page-link" onClick={() => table.nextPage()}>
            Siguiente
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationControls;
